import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef, Input, Output, EventEmitter, ViewChild, TemplateRef, Inject } from '@angular/core';
import {
  FormsModule,
  FormGroup,
  FormBuilder,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  AbstractControl,
  ValidationErrors,
  ControlValueAccessor,
  Validator,
  FormControlName
} from '@angular/forms';
import { AppCommonModule } from '@app/components/app.common.module';
import { TranslateModule } from "@ngx-translate/core";
import { StandardFinancialSetupAttribute } from "@app/pages/quote/standard-quote/model/financial-setup.model";
import {
  DealerType,
  optionsProductTypes, AttributeType,
  PartialFilterType,
  filterTypes,
  filtersProductType
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/filters/filters-form/FilterConfig";
import { TippyDirective } from "@ngneat/helipopper";
import {
  ConditionTemplateComponent
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/condition/condition-template/condition-template.component";
import {
  ModelTemplateComponent
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/model-template/model-template.component";
import { ModalService } from "@components/modal/modal.service";
import {
  FinancialSetupModel
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/model-template/financial-setup.model";
import {
  DealerTemplateComponent
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/dealer-template/dealer-template.component";
import { ActivatedRoute, Route } from '@angular/router';
import { FinancialSetupService } from '../../../../financial-setup.service';
import { FinancialProductService } from '@app/pages/quote/standard-quote/catalogs/financial-product/financial-product.service';

type Filter = {
  classification: boolean | null,
  name: string | null,
  modelType: string | null,
  brandId: number | null,
  subBrandId: string | null,
  year: number | null,
}

@Component({
  selector: 'app-filters-form',
  standalone: true,
  templateUrl: './filters-form.component.html',
  styleUrls: ['./filters-form.component.css'],
  imports: [FormsModule, AppCommonModule, CommonModule, TranslateModule, TippyDirective, ConditionTemplateComponent, ModelTemplateComponent, DealerTemplateComponent,],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FiltersFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FiltersFormComponent),
      multi: true,
    },
  ],
})
export class FiltersFormComponent implements OnInit, ControlValueAccessor, Validator {

  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  @ViewChild('dealerTemplate') dealerTemplate!: TemplateRef<any>;

  @Input() standardFinancialSetupAttributes: StandardFinancialSetupAttribute[] = [];
  @Input() isReadyToEdit: boolean = false;
  @Input() financialSetupModels: FinancialSetupModel[] = [];
  @Input() dealerIds: number[] = [];
  @Input() financialSetupForm: FormGroup;
  @Input() classification: boolean;

  @Output() standardFinancialSetupAttributesChange = new EventEmitter<StandardFinancialSetupAttribute[]>();
  @Output() modelSelectedEmit = new EventEmitter<FinancialSetupModel[]>();
  @Output() dealerSelectedEmit = new EventEmitter<number[]>();

  form: FormGroup;
  optionsProductType = optionsProductTypes;
  modelType: any;
  filterModels: any = {};
  onlyCheckedModels: boolean = false;
  allStates: { [key: string]: boolean } = {};

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private financialSetupService: FinancialSetupService,
    private financialProductService: FinancialProductService,
  ) {
    this.createForm();
  }

  ngOnInit() {
    /* implementacio en TODO ALDO
    this.route.params.subscribe((params: any) => {
      if (params.id) {
        // Edit
        this.financialSetupService.getFinancialSetupFilterStatus(params.id).subscribe({
          next: (response: any) => {
            //TODO: Implement
            // this.filterModels = response.data;
          },
          error: (error: any) => {
            console.error(error);
          }
        });
      }
    });*/
    this.createForm();
    this.initializeOptionsProductType()

  }

  ngOnChanges() {
    if (this.standardFinancialSetupAttributes.length) {
      this.initializeOptionsProductType()
      this.updateForm()
    }
  }




  initializeOptionsProductType() {
    this.optionsProductType.forEach((option: any) => {
      option.filterType.filter.forEach((filter: any) => {
        const matchingAttribute = this.standardFinancialSetupAttributes.find(attr => attr.value === filter.value);
        filter.partial = matchingAttribute ? matchingAttribute.partial : null;
      });
    });
  }

  updateForm() {
    this.form = this.fb.group({
      buses: [
        this.findAttributeByValue(AttributeType.BUSES)?.value
        , []],
      trucks: [
        this.findAttributeByValue(AttributeType.TRUCKS)?.value
        , []],
      tracts: [
        this.findAttributeByValue(AttributeType.TRACTS)?.value
        , []],
      accessories: [
        this.findAttributeByValue(AttributeType.ACCESSORIES)?.value
        , []],
      vans: [
        this.findAttributeByValue(AttributeType.VANS)?.value
        , []],
      nonDaimler: [
        this.findAttributeByValue(AttributeType.NON_DAIMLER)?.value
        , []],
      legalPerson: [this.findAttributeByValue(AttributeType.LEGAL_PERSON)?.value, []],
      naturalPerson: [
        this.findAttributeByValue(AttributeType.NATURAL_PERSON)?.value
        , []],
      dealers: [
        this.findAttributeByValue(AttributeType.DEALERS)?.value
        , []],
      web: [
        this.findAttributeByValue(AttributeType.WEB)?.value
        , []],
      commercialManagement: [
        this.findAttributeByValue(AttributeType.COMMERCIAL_MANAGEMENT)?.value
        , []],
      dealersFull: [
        this.findAttributeByValue(AttributeType.DEALER_FULL)?.value
        , []],
      dealersPartial: [
        this.findAttributeByValue(AttributeType.DEALER_PARTIAL)?.value
        , []],
    });
  }

  createForm() {
    if (!this.fb || !this.form)
      if (!this.isReadyToEdit) {
        this.form = this.fb.group({
          buses: ['', []],
          trucks: ['', []],
          tracts: ['', []],
          accessories: ['', []],
          vans: ['', []],
          nonDaimler: ['', []],
          legalPerson: ['', []],
          naturalPerson: ['', []],
          dealers: ['', []],
          web: ['', []],
          dealersFull: ['', []],
          dealersPartial: ['', []],
          commercialManagement: ['', []],
        });
      }
  }

  findAttributeByValue(value: string): StandardFinancialSetupAttribute | undefined {
    return this.standardFinancialSetupAttributes.find((item) => item.value === value);
  }

  //#region CVA
  writeValue(value: any): void {
    if (value) {
      this.form.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange = (_: any) => { };
  private onTouched = () => { };

  //#endregion

  //#region Validator
  validate(_control: AbstractControl<any, any>): ValidationErrors | null {
    return this.form.valid ? null : { invalidFormCustomer: true };
  }

  onProductTypeChange(event: any, controlName: string, value: string, type: string) {
    if (event.target.checked) {
        this.form.controls[controlName].setValue(AttributeType[value as keyof typeof AttributeType]);
        this.addFilter({ id: null, type: type, value: value, partial: false });
        // No cargar todos los modelos en memoria: partial=false ("Todos") se persiste solo en el atributo.
        this.allStates[value] = false;

        // Actualizar el partial del filtro en optionsProductType
        this.updateFilterPartial(value, false);
    } else {
        this.form.controls[controlName].setValue(AttributeType.NONE);
        this.deleteFilter({ id: null, type: type, value: value });
        for (let i = this.financialSetupModels.length - 1; i >= 0; i--) {
            if (this.financialSetupModels[i].modelType === value) {
                this.financialSetupModels.splice(i, 1);

            }
        }
        const filterIndex = this.standardFinancialSetupAttributes.findIndex((item) => item.value === value);
        if (filterIndex !== -1) {
            this.standardFinancialSetupAttributes[filterIndex].partial = null;
        }
        this.allStates[value] = true;
        
        // Actualizar el partial del filtro en optionsProductType a null para que se desmarque
        this.updateFilterPartial(value, null);
    }
}

  private updateFilterPartial(value: string, partialValue: boolean | null) {
    this.optionsProductType.forEach((option: any) => {
      if (option.filterType.type === filterTypes.PRODUCT_TYPE) {
        const filter = option.filterType.filter.find((f: any) => f.value === value);
        if (filter) {
          filter.partial = partialValue;
        }
      }
    });
  }

/**
 * Carga explícita de todos los modelos de un tipo (evitar en flujo normal de checkbox "Todos").
 * Reservado si en el futuro se necesita precargar IDs.
 */
loadModelsByType(value: string) {
  const params: Filter = {
      classification: this.classification,
      name: null,
      modelType: value,
      brandId: null,
      subBrandId: null,
      year: null,
  };

  this.financialProductService.getModelsToFinancialSetup(params).subscribe({
      next: (response) => {
          if (response.status) {
              const models: FinancialSetupModel[] = response.data;

              models.forEach((model) => {
                  const exists = this.financialSetupModels.some(
                      (selectedModel) => selectedModel.id === model.id
                  );
                  if (!exists) {
                      this.financialSetupModels.push({
                          ...model,
                          isChecked: true,
                      });
                  } else {
                      const existingModel = this.financialSetupModels.find(
                          (selectedModel) => selectedModel.id === model.id
                      );
                      if (existingModel) {
                          existingModel.isChecked = true;
                      }
                  }
              });
              if (this.onlyCheckedModels) {
                  this.financialSetupModels = this.financialSetupModels.filter((model) => model.isChecked);
              }
          }
      },
      error: (_error) => {
          console.error("Error al cargar los modelos", _error);
      },
  });
}

  private upsertProductTypeAttribute(
    value: string,
    partial: boolean,
    id: number | null | undefined
  ): void {
    const idx = this.standardFinancialSetupAttributes.findIndex(
      (f) => f.value === value && f.type === 'PRODUCT_TYPE'
    );
    const row: StandardFinancialSetupAttribute = {
      id: id ?? null,
      type: 'PRODUCT_TYPE',
      value,
      partial,
    };
    if (idx !== -1) {
      const prev = this.standardFinancialSetupAttributes[idx];
      this.standardFinancialSetupAttributes[idx] = {
        ...prev,
        ...row,
        id: id ?? prev.id ?? null,
      };
    } else {
      this.standardFinancialSetupAttributes.push(row);
    }
  }

  onDealerTypeChange(event: any, controlName: string, value: string) {
    if (event.target.checked) {
      this.form.controls[controlName].setValue(AttributeType[value as keyof typeof AttributeType]);
      const otherControlName = controlName === 'dealersFull' ? 'dealersPartial' : 'dealersFull';
      this.form.controls[otherControlName].setValue(AttributeType.NONE);
      this.addFilter({ id: null, type: 'DEALER_TYPE', value: value });
      const otherValue = value === 'DEALER_FULL' ? 'DEALER_PARTIAL' : 'DEALER_FULL';
      this.deleteFilter({ id: null, type: 'DEALER_TYPE', value: otherValue });
    }
  }

  onTypeChange(event: any, controlName: string, value: string, type: string) {
    if (event.target.checked) {
      this.form.controls[controlName].setValue(AttributeType[value as keyof typeof AttributeType]);
      this.addFilter({ id: null, type: type, value: value });
    } else {
      this.form.controls[controlName].setValue(AttributeType.NONE);
      this.deleteFilter({ id: null, type: type, value: value });
    }
  }


  addFilter(filter: StandardFinancialSetupAttribute) {
    if (!filter) return;
    const exist = this.standardFinancialSetupAttributes.find((item) => item.value === filter.value);
    if (!exist) {
      this.standardFinancialSetupAttributes.push(filter);
      this.standardFinancialSetupAttributesChange.emit(this.standardFinancialSetupAttributes);
    }
  }

  deleteFilter(filter: StandardFinancialSetupAttribute) {
    if (!filter) return;
    this.standardFinancialSetupAttributes = this.standardFinancialSetupAttributes.filter((item) => item.value !== filter.value);
    this.standardFinancialSetupAttributesChange.emit(this.standardFinancialSetupAttributes);
  }


  openModalFilter(filterType: any) {
    this.modelType = filterType;
    // this.isEdit = false;
    this.modalService.component = this.modalTemplate;
    this.modalService.openModal();
  }

  openDealerModal(filter: any) {
    this.modalService.component = this.dealerTemplate;
    this.modalService.openModal();
  }

  modelSelected(result: { models: FinancialSetupModel[], filter: any }) {
    const value = result.filter.value;
    const partialVal = result.filter.partial;
    const otherModels = this.financialSetupModels.filter((m) => m.modelType !== value);

    if (partialVal === false) {
      // Todos: no persistir lista de unidades; solo bandera partial=false
      this.financialSetupModels = otherModels;
      this.upsertProductTypeAttribute(value, false, result.filter.id);
      this.updateFilterPartial(value, false);
      this.allStates[value] = false;
    } else if (partialVal === true) {
      const forType = (result.models || []).filter((m) => m.modelType === value);
      this.financialSetupModels = [...otherModels, ...forType];
      this.upsertProductTypeAttribute(value, true, result.filter.id);
      this.updateFilterPartial(value, true);
      this.allStates[value] = true;
    } else {
      const forType = (result.models || []).filter((m) => m.modelType === value);
      if (forType.length === 0) {
        this.financialSetupModels = otherModels;
        this.standardFinancialSetupAttributes = this.standardFinancialSetupAttributes.filter(
          (f) => f.value !== value || f.type !== 'PRODUCT_TYPE'
        );
        this.updateFilterPartial(value, null);
        this.allStates[value] = true;
      } else {
        this.financialSetupModels = [...otherModels, ...forType];
        this.upsertProductTypeAttribute(value, true, result.filter.id);
        this.updateFilterPartial(value, true);
        this.allStates[value] = true;
      }
    }

    this.standardFinancialSetupAttributesChange.emit(this.standardFinancialSetupAttributes);
    this.modelSelectedEmit.emit(this.financialSetupModels);
  }

  dealerSelected(dealerIds: number[]) {
    this.dealerIds = dealerIds;
    this.dealerSelectedEmit.emit(dealerIds);
  }

  showTotalByDealer() {
    if (!this.dealerIds) return "(0)";
    return `(${this.dealerIds.length})`;
  }

  showTotalByType(filter: any): string {
    if (!filter || !this.financialSetupModels) {
      return '';
    }
    const total = this.financialSetupModels.filter((item) => item.modelType === filter.value).length;
    return total === 0 ? '' : `(${total})`;
  }

  protected readonly ProductType = AttributeType;
  protected readonly DealerType = DealerType;
}
